import React from 'react';

type TimelineGraph = {
  spentPath: string;
  estimatePath: string;
  minTs: number;
  maxTs: number;
  estimate: number;
  spent: number;
  maxY: number;
};

type Props = {
  graph: TimelineGraph;
  formatHoursAxisLabel: (seconds: number) => string;
  formatTimelineTick: (timestamp: number, minTs: number, maxTs: number) => string;
};

const TIMELINE_CHART_LEFT = 10;
const TIMELINE_CHART_RIGHT = 98;
const TIMELINE_CHART_TOP = 8;
const TIMELINE_CHART_BOTTOM = 92;

const GitAdminTimelineChartControl: React.FC<Props> = ({ graph, formatHoursAxisLabel, formatTimelineTick }) => {
  return (
    <div className="gitadmin-timeline-chart-control border rounded p-3 bg-light">
      <svg className="gitadmin-timeline-svg" viewBox="0 0 100 100" width="100%" height="220" preserveAspectRatio="none" role="img" aria-label="Timeline de consommation">
        <line className="gitadmin-timeline-grid-line" x1={TIMELINE_CHART_LEFT} y1={(TIMELINE_CHART_TOP + TIMELINE_CHART_BOTTOM) / 2} x2={TIMELINE_CHART_RIGHT} y2={(TIMELINE_CHART_TOP + TIMELINE_CHART_BOTTOM) / 2} />
        <line className="gitadmin-timeline-axis-line" x1={TIMELINE_CHART_LEFT} y1={TIMELINE_CHART_TOP} x2={TIMELINE_CHART_LEFT} y2={TIMELINE_CHART_BOTTOM} />
        <line className="gitadmin-timeline-axis-line" x1={TIMELINE_CHART_LEFT} y1={TIMELINE_CHART_BOTTOM} x2={TIMELINE_CHART_RIGHT} y2={TIMELINE_CHART_BOTTOM} />
        <text className="gitadmin-timeline-axis-text" x={TIMELINE_CHART_LEFT - 1.5} y={TIMELINE_CHART_BOTTOM} textAnchor="end" dominantBaseline="middle" fontSize="4.5">0h</text>
        <text className="gitadmin-timeline-axis-text" x={TIMELINE_CHART_LEFT - 1.5} y={(TIMELINE_CHART_TOP + TIMELINE_CHART_BOTTOM) / 2} textAnchor="end" dominantBaseline="middle" fontSize="4.5">
          {formatHoursAxisLabel(Math.max(1, graph.maxY) / 2)}
        </text>
        <text className="gitadmin-timeline-axis-text" x={TIMELINE_CHART_LEFT - 1.5} y={TIMELINE_CHART_TOP} textAnchor="end" dominantBaseline="middle" fontSize="4.5">
          {formatHoursAxisLabel(Math.max(1, graph.maxY))}
        </text>
        {graph.estimatePath && (
          <path className="gitadmin-timeline-estimate-path" d={graph.estimatePath} />
        )}
        {graph.spentPath && (
          <path className="gitadmin-timeline-spent-path" d={graph.spentPath} />
        )}
      </svg>
      <div className="d-flex justify-content-between small mt-2 gitadmin-timeline-caption">
        <span>{formatTimelineTick(graph.minTs, graph.minTs, graph.maxTs)}</span>
        <span>{formatTimelineTick(graph.maxTs, graph.minTs, graph.maxTs)}</span>
      </div>
      <div className="small mt-1 gitadmin-timeline-caption">
        Ligne bleue pointillée: historique de l'estimation | Ligne verte: historique du consommé
      </div>
    </div>
  );
};

export default GitAdminTimelineChartControl;
